/**
 * Navigates back to the event page while removing specified parameters from the URL.
 * @param {object} history - The history object from React Router.
 * @returns {void}
 */

export const backToEventPage = (history) => {
  const {
    location: {pathname, search},
  } = history || {};

  if (pathname) {
    const params = new URLSearchParams(search);
    ['byo', 'byo_qty', 'ticket_id'].forEach((param) => params.delete(param));
    const newUrl = params.toString() ? `${pathname}?${params.toString()}` : pathname;
    history.push(newUrl);
  }
};
